import { render } from "./FamilyUsersModal.vue?vue&type=template&id=51cfd11c"
import script from "./FamilyUsersModal.vue?vue&type=script&lang=js"
export * from "./FamilyUsersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__